var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.467,
    height: 16,
    viewBox: "0 0 23.467 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a2a2a2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.233,6.75a12.615,12.615,0,0,0-11.733,8,12.6,12.6,0,0,0,23.467,0A12.615,12.615,0,0,0,13.233,6.75Zm0,13.333a5.333,5.333,0,1,1,5.333-5.333A5.335,5.335,0,0,1,13.233,20.083Zm0-8.533a3.2,3.2,0,1,0,3.2,3.2A3.2,3.2,0,0,0,13.233,11.55Z",
    transform: "translate(-1.5 -6.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c0142c670faa4682ac656c1212201126.svg";
export { ForwardRef as ReactComponent };